import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var RootVariableForInput = {
  INPUT_ICON_SIZE: '--gui-input-icon-size',
  INPUT_CLEAR_ICON_SIZE: '--gui-input-clear-icon-size',
  INPUT_CLEAR_ICON_COLOR: '--gui-input-clear-icon-color',
  INPUT_ICON_MARGIN: '--gui-input-icon-margin',
  INPUT_ICON_COLOR: '--gui-input-icon-color',
  INPUT_DISABLED_ICON_COLOR: '--gui-input-disabled-icon-color',
  INPUT_FONT_SIZE: '--gui-input-font-size',
  INPUT_FONT_WEIGHT: '--gui-input-font-weight',
  INPUT_PLACEHOLDER_FONT_SIZE: '--gui-input-placeholder-font-size',
  INPUT_PLACEHOLDER_FONT_WEIGHT: '--gui-input-placeholder-font-weight',
  INPUT_PLACEHOLDER_COLOR: '--gui-input-placeholder-color',
  INPUT_DISABLED_PLACEHOLDER_COLOR: '--gui-input-disabled-placeholder-color',
  INPUT_INVALID_PLACEHOLDER_COLOR: '--gui-input-invalid-placeholder-color',
  INPUT_HEIGHT: '--gui-input-h',
  INPUT_RADIUS: '--gui-input-radius',
  INPUT_BORDER: '--gui-input-border',
  INPUT_BORDER_WIDTH: '--gui-input-border-width',
  INPUT_BORDER_COLOR: '--gui-input-border-color',
  INPUT_BG: '--gui-input-bg',
  INPUT_COLOR: '--gui-input-color',
  INPUT_ACTIVE_BORDER_COLOR: '--gui-input-active-border-color',
  INPUT_ACTIVE_BG: '--gui-input-active-bg',
  INPUT_ACTIVE_COLOR: '--gui-input-active-color',
  INPUT_HOVER_BORDER_COLOR: '--gui-input-hover-border-color',
  INPUT_HOVER_BG: '--gui-input-hover-bg',
  INPUT_HOVER_COLOR: '--gui-input-hover-color',
  INPUT_DISABLED_BORDER_COLOR: '--gui-input-disabled-border-color',
  INPUT_DISABLED_BG: '--gui-input-disabled-bg',
  INPUT_DISABLED_COLOR: '--gui-input-disabled-color',
  INPUT_INVALID_BORDER_COLOR: '--gui-input-invalid-border-color',
  INPUT_INVALID_BG: '--gui-input-invalid-bg',
  INPUT_INVALID_COLOR: '--gui-input-invalid-color',
  INPUT_BASE_PADDING: '--gui-input-base-padding'
};
var RootVariableForInputWrapper = {
  INPUT_WRAPPER_REQUIRED_COLOR: '--gui-input-wrapper-required-color',
  INPUT_WRAPPER_LABEL_FONT_SIZE: '--gui-input-wrapper-label-font-size',
  INPUT_WRAPPER_LABEL_FONT_WEIGHT: '--gui-input-wrapper-label-font-weight',
  INPUT_WRAPPER_LABEL_COLOR: '--gui-input-wrapper-label-color',
  INPUT_WRAPPER_LABEL_GAP: '--gui-input-wrapper-label-gap',
  INPUT_WRAPPER_LABEL_LINE_HEIGHT: '--gui-input-wrapper-label-line-height',
  INPUT_WRAPPER_ERROR_FONT_SIZE: '--gui-input-wrapper-error-font-size',
  INPUT_WRAPPER_ERROR_FONT_WEIGHT: '--gui-input-wrapper-error-font-weight',
  INPUT_WRAPPER_ERROR_COLOR: '--gui-input-wrapper-error-color',
  INPUT_WRAPPER_ERROR_GAP: '--gui-input-wrapper-error-gap',
  INPUT_WRAPPER_ERROR_LINE_HEIGHT: '--gui-input-wrapper-error-line-height',
  INPUT_WRAPPER_DESC_FONT_SIZE: '--gui-input-wrapper-desc-font-size',
  INPUT_WRAPPER_DESC_FONT_WEIGHT: '--gui-input-wrapper-desc-font-weight',
  INPUT_WRAPPER_DESC_COLOR: '--gui-input-wrapper-desc-color',
  INPUT_WRAPPER_DESC_GAP: '--gui-input-wrapper-desc-gap',
  INPUT_WRAPPER_DESC_LINE_HEIGHT: '--gui-input-wrapper-desc-line-height'
};
var RootVariable = _objectSpread2(_objectSpread2({}, RootVariableForInput), RootVariableForInputWrapper);

export { RootVariable, RootVariableForInput, RootVariableForInputWrapper };
//# sourceMappingURL=constant.js.map
